/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeurekaHostNameCredentialData } from './HeurekaHostNameCredentialData';
import {
    HeurekaHostNameCredentialDataFromJSON,
    HeurekaHostNameCredentialDataFromJSONTyped,
    HeurekaHostNameCredentialDataToJSON,
    HeurekaHostNameCredentialDataToJSONTyped,
} from './HeurekaHostNameCredentialData';

/**
 * 
 * @export
 * @interface HeurekaIntegrationData
 */
export interface HeurekaIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof HeurekaIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof HeurekaIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof HeurekaIntegrationData
     */
    paused?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {Array<HeurekaHostNameCredentialData>}
     * @memberof HeurekaIntegrationData
     */
    hostNameAndApiKeyList?: Array<HeurekaHostNameCredentialData>;
}

/**
 * Check if a given object implements the HeurekaIntegrationData interface.
 */
export function instanceOfHeurekaIntegrationData(value: object): value is HeurekaIntegrationData {
    return true;
}

export function HeurekaIntegrationDataFromJSON(json: any): HeurekaIntegrationData {
    return HeurekaIntegrationDataFromJSONTyped(json, false);
}

export function HeurekaIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeurekaIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] === undefined ? undefined : json['lastRegularUpdate'] === null ? null : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] === undefined ? undefined : json['lastHistoricalUpdate'] === null ? null : json['lastHistoricalUpdate'],
        'paused': json['paused'] == null ? undefined : json['paused'],
        'project': json['project'] == null ? undefined : json['project'],
        'hostNameAndApiKeyList': json['hostNameAndApiKeyList'] == null ? undefined : ((json['hostNameAndApiKeyList'] as Array<any>).map(HeurekaHostNameCredentialDataFromJSON)),
    };
}

export function HeurekaIntegrationDataToJSON(json: any): HeurekaIntegrationData {
    return HeurekaIntegrationDataToJSONTyped(json, false);
}

export function HeurekaIntegrationDataToJSONTyped(value?: HeurekaIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'paused': value['paused'],
        'project': value['project'],
        'hostNameAndApiKeyList': value['hostNameAndApiKeyList'] == null ? undefined : ((value['hostNameAndApiKeyList'] as Array<any>).map(HeurekaHostNameCredentialDataToJSON)),
    };
}

